import { Component, OnInit, Input} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, NavigationStart } from '@angular/router';

//import { GridOptions, ColDef, AllModules } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from 'ag-grid-community';


import { WorkOrderService } from '../../../../common/services/work-order.service';
import { RouterLinkRendererComponent } from '../../../../common/components/ag-grid/router-link-renderer.component';
import { UserIdentity } from '../../../../models/user-identity.model';
import { AuthService } from '../../../../services/auth.service';
import { OrganizationStub } from '../../../../common/models/organization.model';
import { FlowInstanceService } from '../../../../flow/services/flow-instance.service';
import { FlowIndex } from '../../../../common/models/flow.dto';
import { DateService } from '../../../../common/services/date.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { dateComparator } from '../../../../common/components/data-table/comparators/data-table.comparators';
import { DataCorrectionService } from '../../../../services/dataCorrection.service';
import { GridFormatterService } from '../../../../common/services/grid-formatter.service';
import { ModalInfoComponent } from '../../../../common/components/ag-grid/modal-info.component';

@Component({
    selector: 'organization-management-external-widget',
    templateUrl: './organization-management-external-widget.component.html',
    styleUrls: ['./organization-management-external-widget.component.scss'],
    standalone: false
})
export class OrganizationManagementExternalWidgetComponent implements OnInit {
    @Input() widgetTitle: string;


	notSubmittedGridOptions: GridOptions;
	notSubmittedGridApi?: GridApi;
	pendingReviewGridOptions: GridOptions;
	pendingReviewGridApi?: GridApi;
	approvedGridOptions: GridOptions;
	approvedGridApi?: GridApi;
	returnedGridOptions: GridOptions;
	returnedGridApi?: GridApi;
	deniedGridOptions: GridOptions;
	deniedGridApi?: GridApi;
    orgStubs: OrganizationStub[];
    subscriptions: Subscription = new Subscription();
    notSubmitted: FlowIndex[];
    pendingReview: FlowIndex[];
    approved: FlowIndex[];
    returned: FlowIndex[];
    pendingDenial: FlowIndex[];
    denied: FlowIndex[];
    selectedItem: any;

    columnApplicationNumberColumn = {
        headerClass: "wrapped",
        headerName: 'Application #',
        headerTooltip: 'Application #',
        tooltipField: 'flowIdentifier',
        field: 'flowIdentifier',
        cellRendererSelector: (params) => {
            if (params.data.onBehalf) {
                return {
                    component: ModalInfoComponent,
                    params: {
                        modalText: (data) => { return `Application ${data.flowIdentifier} is a paper submission that must be completed by ODNR.`; },
                        text: (data) => { return data.flowIdentifier; }
                    }
                }
            } else {
                return {
                    component: RouterLinkRendererComponent,
                    params: {
                        textField: 'flowIdentifier',
                        flowIdField: 'flowId'
                    }
                }
            }
        },
        filter: "agTextColumnFilter",
        filterParams: this.gridFormatterService.defaultTextFilterParams,
    } as ColDef;

    columnPendingTabApplicationNumber: ColDef = {
        headerClass: "wrapped",
        headerName: 'Application #',
        headerTooltip: 'Application #',
        tooltipField: 'flowIdentifier',
        field: 'flowIdentifier',
        filter: "agTextColumnFilter",
        filterParams: this.gridFormatterService.defaultTextFilterParams,
    };

    columnCreatedDate = {
        headerClass: "wrapped",
        headerName: 'Created',
        headerTooltip: 'Created',
        field: 'createdDate',
        tooltipValueGetter: this.gridFormatterService.formatDate('createdDate'),
        valueGetter: this.gridFormatterService.formatDate('createdDate'),
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: this.gridFormatterService.defaultDateFilterParams,
        minWidth: 135,
    } as ColDef;


    //Approved is an end state, so technically, if we go with the last modified date, it should de facto be the approve date
    columnApprovedDate = {
        headerClass: "wrapped",
        headerName: 'Approved',
        headerTooltip: 'Approved',
        field: 'modifiedDate',
        tooltipValueGetter: this.gridFormatterService.formatDate('modifiedDate'),
        valueGetter: this.gridFormatterService.formatDate('modifiedDate'),
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: this.gridFormatterService.defaultDateFilterParams,
        minWidth: 135,
    } as ColDef;

    columnSubmittedDate = {
        headerClass: "wrapped",
        headerName: 'Submitted',
        headerTooltip: 'Submitted',
        field: 'submittedDate',
        tooltipValueGetter: this.gridFormatterService.formatDate('submittedDate'),
        valueGetter: this.gridFormatterService.formatDate('submittedDate'),
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: this.gridFormatterService.defaultDateFilterParams,
        minWidth: 135,
    } as ColDef;

    columnApplicationType = {
        headerClass: "wrapped",
        headerName: 'Type',
        headerTooltip: 'Type',
        field: 'name',
        tooltipField: 'name',
        minWidth: 160,
    } as ColDef;

    //As Denied is an end state, the last modified date will be the time it was denied
    columnDeniedDate: ColDef = {
        headerClass: "wrapped",
        headerName: 'Date Denied',
        headerTooltip: "Date Denied",
        tooltipValueGetter: this.gridFormatterService.formatDate('modifiedDate'),
        field: "deniedDate",
        valueGetter: this.gridFormatterService.formatDate('modifiedDate'),
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: this.gridFormatterService.defaultDateFilterParams,
        minWidth: 100,
        maxWidth: 140
    };

    public notSubmittedColumns: ColDef[] = [this.columnCreatedDate, this.columnApplicationNumberColumn, this.columnApplicationType];
    public pendingReviewColumns: ColDef[] = [this.columnPendingTabApplicationNumber, this.columnSubmittedDate, this.columnApplicationType];
    public approvedReviewColumns: ColDef[] = [this.columnPendingTabApplicationNumber, this.columnApprovedDate, this.columnApplicationType];
    public deniedReviewColumns: ColDef[] = [this.columnSubmittedDate, this.columnPendingTabApplicationNumber, this.columnApplicationType, this.columnDeniedDate];
    public returnedReviewColumns: ColDef[] = [this.columnApplicationNumberColumn, this.columnSubmittedDate, this.columnApplicationType];


    constructor(
        public workOrderService: WorkOrderService,
        public authService: AuthService,
        public datePipe: DatePipe,
        public dataCorrectionService: DataCorrectionService,
        public gridFormatterService: GridFormatterService,
        private flowInstanceService: FlowInstanceService,
        private router: Router,
        public dateService: DateService
    ) {
        this.subscriptions.add(this.flowInstanceService.getReturnedIncompleteApplication("InProgressOrganizationManagementApplications", false, this.user.organizationId)
            .subscribe((result: FlowIndex[]) => {
                this.notSubmitted = result;
            }));

        this.subscriptions.add(this.flowInstanceService.queryFlowIndices("PendingOrganizationManagementApplications", this.user.organizationId)
            .subscribe((result: FlowIndex[]) => {
                this.pendingReview = this.sortFlowIndices(result);
            }));

        this.subscriptions.add(this.flowInstanceService.getReturnedIncompleteApplication("ReturnedOrganizationManagementApplications", true, this.user.organizationId)
            .subscribe((result: FlowIndex[]) => {
                this.returned = this.sortFlowIndices(result);
            }));

        this.subscriptions.add(this.flowInstanceService.queryFlowIndices("ApprovedOrganizationManagementApplications", this.user.organizationId)
            .subscribe((result: FlowIndex[]) => {
                this.approved = this.sortFlowIndices(result);
            }));

        this.subscriptions.add(this.flowInstanceService.queryFlowIndices("DeniedOrganizationManagementApplications", this.user.organizationId)
            .subscribe((result: FlowIndex[]) => {
                this.denied = this.sortFlowIndices(result);
            }));
    }

    ngOnInit() {
		this.notSubmittedGridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.notSubmittedColumns);
		this.notSubmittedGridOptions.onGridReady = (params) => { 
            this.notSubmittedGridApi = params.api; 
            this.notSubmittedGridApi.sizeColumnsToFit();
        };
        this.notSubmittedGridOptions.headerHeight = 40;
		this.pendingReviewGridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.pendingReviewColumns);
		this.pendingReviewGridOptions.onGridReady = (params) => { 
            this.pendingReviewGridApi = params.api; 
            this.pendingReviewGridApi.sizeColumnsToFit();
        };
        this.pendingReviewGridOptions.headerHeight = 40;
		this.approvedGridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.approvedReviewColumns);
		this.approvedGridOptions.onGridReady = (params) => { 
            this.approvedGridApi = params.api; 
            this.approvedGridApi.sizeColumnsToFit();
        };
        this.approvedGridOptions.headerHeight = 40;
		this.deniedGridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.deniedReviewColumns);
		this.deniedGridOptions.onGridReady = (params) => { 
            this.deniedGridApi = params.api; 
            this.deniedGridApi.sizeColumnsToFit();
        };
        this.deniedGridOptions.headerHeight = 40;
		this.returnedGridOptions = this.gridFormatterService.BuildDefaultGridOptionsWithColumns(this.returnedReviewColumns);
		this.returnedGridOptions.onGridReady = (params) => { 
            this.returnedGridApi = params.api; 
            this.returnedGridApi.sizeColumnsToFit();
        };
        this.returnedGridOptions.headerHeight = 40;
        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.subscriptions.unsubscribe();
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    onTabClicked(): void {
        this.notSubmittedGridApi.sizeColumnsToFit();
        this.pendingReviewGridApi.sizeColumnsToFit();
        this.approvedGridApi.sizeColumnsToFit();
        this.deniedGridApi.sizeColumnsToFit();
        this.returnedGridApi.sizeColumnsToFit();
    }

    get user(): UserIdentity {
        return this.authService.User;
    }

    sortFlowIndices(indices: FlowIndex[]): FlowIndex[] { //sort by date submitted if available, then by created date if not
        return indices.sort((a, b) => {
            if (a.dateSubmitted < b.dateSubmitted) return -1;
            if (a.dateSubmitted > b.dateSubmitted) return 1;
            if (a.createdDate < b.createdDate) return -1;
            if (a.createdDate > b.createdDate) return 1;
            return 0;
        });
    }
}
